import React from 'react';
import loadable from '@app/ui/components/LazyLoad';
import { useShowSmsModal } from './hooks';

//
// Component to load
const SMSModal = loadable(
  () => import(/* webpackChunkName: "lazy.SMSModal" */ './SMSModal'),
);

const useShouldShow = (): boolean => useShowSmsModal();

const GlobalSMSModalLazy = () => {
  const shouldShow = useShouldShow();

  if (!shouldShow) {
    return null;
  }

  return <SMSModal />;
};

export default GlobalSMSModalLazy;
